import React from 'react'
import { Outlet } from 'react-router-dom'

export const Accounting = () => {
  return (
    <Outlet />
  )
}
